// ** Custom Components
import SwiperVideoPlayer from "components/video/VideoPlayer/SwiperVideoPlayer";
import { StyledOverlay } from "styles/components/Overlay.styled";

// #####################################################

const CarouselSwiperSlideNew = ({
	item,
	itemIdFromUrl,
	contentInfo,
	contentIdUrl,
	carouselSwiper,
	isZoomedOut,
}) => {
	const calculateBackgroundSize = (
		containerWidth,
		containerHeight,
		imageWidth,
		imageHeight
	) => {
		let renderedWidth, renderedHeight;

		const imageAspectRatio = imageWidth / imageHeight;
		const containerAspectRatio = containerWidth / containerHeight;

		if (imageAspectRatio > containerAspectRatio) {
			renderedWidth = containerWidth;
			renderedHeight = containerWidth / imageAspectRatio;
		} else {
			renderedHeight = containerHeight;
			renderedWidth = containerHeight * imageAspectRatio;
		}

		return {
			renderedWidth: renderedWidth ? renderedWidth.toFixed(0) : 0,
			renderedHeight: renderedHeight ? renderedHeight.toFixed(0) : 0,
		};
	};

	const { renderedWidth, renderedHeight } = calculateBackgroundSize(
		carouselSwiper.width,
		carouselSwiper.height,
		item.width,
		item.height
	);

	return item?.media_type === "photo" ? (
		<div
			style={{
				position: "relative",
				height: "100%",
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
			className="swiper-zoom-container"
		>
			<StyledOverlay style={{ zIndex: 3 }} />
			<img
				src={item?.media?.big}
				loading="lazy"
				style={{
					position: "relative",
					zIndex: 2,
				}}
			/>
			<div
				style={{
					backgroundColor: isZoomedOut ? "transparent" : "#303030",
					width: `${renderedWidth}px`,
					height: `${renderedHeight}px`,
					position: "absolute",
					zIndex: 1,
				}}
			/>
		</div>
	) : item?.media_type === "video" ? (
		<SwiperVideoPlayer
			source={{
				src: item.media.video,
				type: "video/mp4",
			}}
			poster={item?.media?.thumbs?.poster}
			contentInfo={contentInfo}
			contentIdUrl={contentIdUrl}
			renderedWidth={renderedWidth}
			renderedHeight={renderedHeight}
			correctVideoId={item?.id?.toString() === itemIdFromUrl}
		/>
	) : null;
};

export default CarouselSwiperSlideNew;
